import useEditShopContext from 'contexts/shop.context';
import React from 'react';

const PreviewShopFees = () => {
  const { shopDetails } = useEditShopContext();

  const details: { value: string | number | null | undefined; label: string }[] = [
    { value: shopDetails?.platform_fee, label: 'Platform Fee (%)' },
    { value: shopDetails?.platform_fee_cap, label: 'Platform Fee Cap (₦)' },
    { value: shopDetails?.service_fee, label: 'Service Fee (%)' },
    { value: shopDetails?.service_fee_cap, label: 'Service Fee Cap (₦)' }
  ];

  return (
    <div className='space-y-6'>
      {details.map((detail) => {
        const hasValue =
          detail.value !== null &&
          detail.value !== undefined &&
          !(typeof detail.value === 'string' && detail.value.trim() === '');

        return (
          <div
            key={detail.label}
            className='border border-gray-1 rounded-lg pl-3 flex items-center mb-4'>
            <h2 className='text-sm text-gray-5 w-40'>{detail.label}</h2>
            {hasValue ? (
              <span className='p-3.5 font-medium'>{detail.value}</span>
            ) : (
              <span className='p-3.5'>N/A</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PreviewShopFees;
